export const toDecimal2 = x => {
  let f = Math.round(x * 100) / 100;
  let s = String(f);
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
};

export const priceFenToYuan = price => {
  return price === '' || price === null || isNaN(price) ? '' : toDecimal2(price / 100);
};
export function throttle(func, wait, options = { leading: true, trailing: false }) {
  var timeout, context, args, result;
  var previous = 0;
  if (!options) options = {};

  var later = function() {
    previous = options.leading === false ? 0 : new Date().getTime();
    timeout = null;
    func.apply(context, args);
    if (!timeout) context = args = null;
  };

  var throttled = function() {
    var now = new Date().getTime();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
  };
  return throttled;
}
export const submitOnce = (function() {
  var isRunning = false;
  return function(callback, context, time) {
    if (!isRunning) {
      isRunning = true;
      var temp = callback.call(context);
      // if (temp && temp.constructor === Promise) {
      // 如果temp含有then Function，则认为temp是Promise，不直接通过Promise判断的原因是callback返回的Promise可能是一个"伪Promise"
      if (temp && temp.then && temp.then.constructor === Function) {
        temp.then(() => (isRunning = false)).catch(() => (isRunning = false));
      } else {
        setTimeout(function() {
          isRunning = false;
        }, time || 1000);
      }
      return temp;
    }
  };
})();

export const parseCountDown = ms => {
  let duration = ms + 60000;
  let minutes = parseInt(((duration / (1000 * 60)) % 60) + '');
  let hours = Number(parseInt(duration / (1000 * 60 * 60) + ''));
  if (duration < 0) {
    return '0天0小时0分';
  } else {
    if (Math.floor(hours / 24) < 1) {
      return (hours % 24) + '小时' + minutes + '分';
    }
    return Math.floor(hours / 24) + '天' + (hours % 24) + '小时' + minutes + '分';
  }
};
export const isEmpty = val => [undefined, 'null', '""', '[]', '{}'].includes(JSON.stringify(val));

export const getRouter = router => {
  if (router) {
    return router;
  }
  return {
    push: function(param) {
      let path = '';
      let query = '';
      if (typeof param === 'string') {
        path = param;
      } else {
        path = param.path;
        query = param.query
          ? `?${Object.entries(param.query)
              .map(item => `${item[0]}=${item[1]}`)
              .join('&')}`
          : '';
      }
      window.location.href = `${process.env.VUE_APP_WEB_BASE_URL}#${path}${query}`;
    }
  };
};

function GetRequest() {
  const url = window.location.href.split('?')[1];
  if(!url){
    return {}
  }
  let theRequest = new Object();
  if (url.indexOf('?') != -1) {
    let str = url.substr(1);
    strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
  }
  return theRequest;
}

export const getRoute = route => {
  if (route) {
    return route;
  }
  return {
    query: GetRequest()
  };
};
